import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import UsersSettings from "../pages/Settings/UsersSettings";
import GeminiSettings from "../pages/Settings/GeminiSettings";
import LabSettings from "../pages/Settings/Lab";
import TagsSettings from "../pages/Settings/TagsSettings";
import CustomFieldsSettings from "../pages/Settings/CustomFieldsSettings";
import SystemLogs from "../pages/SystemLogs";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import CampaignsAds from "../pages/Masivo/CampaignsAds";
import CampaignsAdsProgram from "../pages/Masivo/CampaignsAdsProgram";
import BulkMessages from "../pages/Masivo/BulkMessages";
import BulkMessagesProgram from "../pages/Masivo/BulkMessagesProgram";
import Transmission from "../pages/Masivo/Transmission";
import Agente from "../pages/Agente";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/agente" component={Agente} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/settings/users" component={UsersSettings} isPrivate />
                <Route exact path="/settings/gemini" component={GeminiSettings} isPrivate />
                <Route exact path="/settings/lab" component={LabSettings} isPrivate />
                <Route exact path="/settings/tags" component={TagsSettings} isPrivate />
                <Route exact path="/settings/fields" component={CustomFieldsSettings} isPrivate />
                <Route exact path="/settings/system-logs" component={SystemLogs} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
                <Route exact path="/campaigns-ads" component={CampaignsAds} isPrivate />
                <Route exact path="/campaigns/:flowId" component={CampaignsAdsProgram} isPrivate />
                <Route exact path="/bulk-messages" component={BulkMessages} isPrivate />
                <Route exact path="/bulk-messages/:flowId" component={BulkMessagesProgram} isPrivate />
                <Route exact path="/transmission" component={Transmission} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
